import { compose, concat, last, split, __ } from 'ramda';

const formatCommissionNumber = compose(concat(__, '%'), last, split('_'));

export default formatCommissionNumber;
